<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">5.</span>
          <span>Adult Service Priority</span>
        </div>
        <p>Please enter your information regarding your eligibility in WIOA.</p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-type">
            <p class="heavy-text">Homeless</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you considered to be legally homeless?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.Homeless.IsHomeless'
                    )
                  "
                >
                  <el-radio-group
                    v-model="adultServicePriority.homeless.isHomeless"
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">Free or Reduced-Price School Lunch</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a recipient of Free or Reduced-Price School Lunches?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.RecipientOfFreeLunch.IsRecipientOfFreeLunch'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      adultServicePriority.recipientOfFreeLunch
                        .isRecipientOfFreeLunch
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload a copy of your School Records.</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="recipientOfFreeLunch"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon recipientOfFreeLunch"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="recipientOfFreeLunchFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">Foster Care</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a current Foster Care Youth or a Former Foster Care
                  Youth?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.FosterCare.IsFosterCare'
                    )
                  "
                >
                  <el-radio-group
                    v-model="adultServicePriority.fosterCare.isFosterCare"
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">Individual with a Disibility</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you considered legally disabled?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.IndividualWithDisability.IsDisabled'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      adultServicePriority.individualWithDisability.isDisabled
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload documentation relating to disability if
                  applicable.</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="individualWithDisability"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon individualWithDisability"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="individualWithDisabilityFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: Detailed information about the liability is not necessary.
            </div>
          </div>
          <div class="content-type">
            <p class="heavy-text">Basic Skills Deficient</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you considered Basic Skills Deficient Legally?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.AdultServicePriority.BasicSkillsDeficient.IsSkillsDeficient'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      adultServicePriority.basicSkillsDeficient
                        .isSkillsDeficient
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text"
                  >Please upload documentation relating to your Basic Skills
                  Deficient ie. School Records.</label
                >
                <el-form-item>
                  <el-upload
                    drag
                    action="basicSkillsDeficient"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon basicSkillsDeficient"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="basicSkillsDeficientFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-note-section">
            <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
            <div class="note-text">
              Note: Detailed information about the liability is not necessary.
            </div>
          </div>

          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import * as utils from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      modelState: {},
      loading: false,
      recipientOfFreeLunchFileList: [],
      individualWithDisabilityFileList: [],
      basicSkillsDeficientFileList: [],
      adultServicePriority: {
        homeless: {
          isHomeless: null
        },
        recipientOfFreeLunch: {
          isRecipientOfFreeLunch: null,
          clientFiles: []
        },
        fosterCare: {
          isFosterCare: null
        },
        individualWithDisability: {
          isDisabled: null,
          clientFiles: []
        },
        basicSkillsDeficient: {
          isSkillsDeficient: null,
          clientFiles: []
        }
      },
      newRecipientOfFreeLunchUploadInd: false,
      newIndividualWithDisabilityUploadInd: false,
      newBasicSkillsDeficientUploadInd: false,
      validFileExtensions: [
        ...utils.imageFileExtensions,
        ...utils.documentFileExtensions
      ],
      document: {
        type: Object,
        default() {
          return {
            id: "",
            name: "",
            filename: "",
            documentObjectId: "",
            documentObjectUrl: "",
            isImage: false
          };
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
      .then(() => {
        if(this.newRecipientOfFreeLunchUploadInd || this.newIndividualWithDisabilityUploadInd || this.newBasicSkillsDeficientUploadInd)
        {
            if(this.adultServicePriority.recipientOfFreeLunch.clientFiles[0].fileId && this.newRecipientOfFreeLunchUploadInd){
              this.navigateAwayRemoveAttachment(this.adultServicePriority.recipientOfFreeLunch.clientFiles[0].fileId);
              this.adultServicePriority.recipientOfFreeLunch.clientFiles = [];
            }
            
            if(this.adultServicePriority.individualWithDisability.clientFiles[0].fileId && this.newIndividualWithDisabilityUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.adultServicePriority.individualWithDisability.clientFiles[0].fileId);
              this.adultServicePriority.individualWithDisability.clientFiles = [];
            }

            if(this.adultServicePriority.basicSkillsDeficient.clientFiles[0].fileId && this.newBasicSkillsDeficientUploadInd)
            {
              this.navigateAwayRemoveAttachment(this.adultServicePriority.basicSkillsDeficient.clientFiles[0].fileId);
              this.adultServicePriority.basicSkillsDeficient.clientFiles = [];
            }

            this.$message.success("Your checklist are saved as draft!");
            localStorage.removeItem("editChecklist");
            next();
        }
        else
        {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        }
      })
      .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0,0);
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          // this.adultServicePriority = res.checklist.adultServicePriority;
          if (res.checklist.adultServicePriority.homeless)
          {
            this.adultServicePriority.homeless = res.checklist.adultServicePriority.homeless;
          }
            
          if (res.checklist.adultServicePriority.recipientOfFreeLunch)
          {
            this.adultServicePriority.recipientOfFreeLunch = res.checklist.adultServicePriority.recipientOfFreeLunch;
            res.checklist.adultServicePriority.recipientOfFreeLunch.clientFiles.forEach(element => {
              this.recipientOfFreeLunchFileList.push({'name': element.fileName, 'url': element.fileId});
            });
          }
            
          if (res.checklist.adultServicePriority.fosterCare)
          {
            this.adultServicePriority.fosterCare = res.checklist.adultServicePriority.fosterCare;
          }
            
          if (res.checklist.adultServicePriority.individualWithDisability)
          {
            this.adultServicePriority.individualWithDisability = res.checklist.adultServicePriority.individualWithDisability;
            res.checklist.adultServicePriority.individualWithDisability.clientFiles.forEach(element => {
              this.individualWithDisabilityFileList.push({'name': element.fileName, 'url': element.fileId});
            });
          }
            
          if (res.checklist.adultServicePriority.basicSkillsDeficient)
          {
            this.adultServicePriority.basicSkillsDeficient = res.checklist.adultServicePriority.basicSkillsDeficient;
            res.checklist.adultServicePriority.basicSkillsDeficient.clientFiles.forEach(element => {
              this.basicSkillsDeficientFileList.push({'name': element.fileName, 'url': element.fileId});
            });
          }
            
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    navigateAwayRemoveAttachment(objectId){
      const param = {
          objectId: objectId,
          bucketType: BucketType.WioaChecklist,
        };
        this.$store
          .dispatch("common/removefile", param)
          .then(() => {
            return true;
          })
          .catch((res) => {
            this.$message.success("Something went wrong. Please contact talentsensus admin.");
            return false
          });
    },
    removeUpload(file, fileList){
      let uploadElement = event.target.parentElement.parentElement.parentElement;
      this.loading = true;
      file.url = (file.url == null && file.name != null) ? file.raw.url : file.url;
      const param = {
          objectId: file.url,
          bucketType: BucketType.WioaChecklist
        };
      this.$store.dispatch("common/removefile", param).then(() => {
        if(uploadElement.classList.contains('recipientOfFreeLunch'))
        {
          this.adultServicePriority.recipientOfFreeLunch.clientFiles = [];
        }
        else if(uploadElement.classList.contains('individualWithDisability'))
        {
          this.adultServicePriority.individualWithDisability.clientFiles = [];
        }
        else if(uploadElement.classList.contains('basicSkillsDeficient'))
        {
          this.adultServicePriority.basicSkillsDeficient.clientFiles = [];
        }
        this.$message.success("Document removed!");
      })
      .catch((res) => {
      })
      .finally(() => {
        this.loading = false;
      });
    },
    handleExceed(){
      this.showPopUpMessage(
          "Upload",
          `You can only upload 1 file.`
        );
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklistFour",
        params: { checklistId: this.getChecklistId() }
      });
    },
    updateCheckList() {
      this.loading = true;
      let checklist = {
        type: 2.3,
        checklist: {
          id:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId,
          adultServicePriority: this.adultServicePriority
        }
      };
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "WioaChecklistSix",
              params: { checklistId: this.getChecklistId() }
            });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocument(param) {
      this.loading = true;

      this.$store
        .dispatch(
          "wioa/generateUploadDocumentMetadata",
          this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.storeDocument(param, metadata);
        })
        .catch(err => param.onError(err, param.file, param.fileList));
    },
    storeDocument(param, metadata) {
      const { file } = param;
      const fileExtension = utils.getFileExtension(file.name);

      this.$store
        .dispatch("common/uploadDocumentWithReturnUrl", {
          file,
          objectId:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
          bucketType: BucketType.WioaChecklist,
          fileExtension
        })
        .then(url => {
          this.document.id = metadata.documentId;
          this.document.filename = file.name;
          this.document.isImage = utils.isImage(file.name);
          this.document.documentObjectId = metadata.documentObjectId;
          this.document.documentObjectUrl = url;

          if (param.action == "recipientOfFreeLunch") {
            this.adultServicePriority.recipientOfFreeLunch.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newRecipientOfFreeLunchUploadInd = true;
          } else if (param.action == "individualWithDisability") {
            this.adultServicePriority.individualWithDisability.clientFiles.push(
              {
                fileId:
                  this.editChecklistId == null
                    ? this.getChecklistId()
                    : this.editChecklistId +
                      "/JobSeeker/" +
                      metadata.documentId,
                fileName: file.name
              }
            );
            this.newIndividualWithDisabilityUploadInd = true;
          } else {
            this.adultServicePriority.basicSkillsDeficient.clientFiles.push({
              fileId:
                this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
              fileName: file.name
            });
            this.newBasicSkillsDeficientUploadInd = true;
          }
          param.file.url = this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId;
        })
        .catch(err => {
          param.onError(err, param.file, param.fileList);
        })
        .finally(() => (this.loading = false));
    },
    beforeUpload(file) {
      const fileExtension = utils.getFileExtension(file.name);

      if (this.validFileExtensions.indexOf(fileExtension) === -1) {
        this.showPopUpMessage(
          "Upload",
          `Invalid file type. Only ${this.validFileExtensions.join(
            ", "
          )} are allowed.`
        );
        this.loading = false;
        return false;
      }

      const fileLimitExceeded = file.size / 1024 / 1024 > 3;
      if (fileLimitExceeded) {
        this.showPopUpMessage("Upload", "File size cannot exceed 3MB");
        this.loading = false;
        return false;
      }

      return true;
    },
    onError() {
      this.loading = false;
      this.presignedUpdateUrl = "";

      this.document.id = "";
      this.document.filename = "";
      this.document.documentObjectId = "";
      this.document.documentObjectUrl = "";
      this.document.isImage = false;

      this.showPopUpMessage("Upload", "Unable to upload file.");
    },
    showPopUpMessage(title, msg, type = "error") {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => false);
    },
    isImage(filename) {
      return utils.isImage(filename);
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>
